export default __webpack_public_path__ + "static/media/closet5-after3-1024w.2bee1172.png";